import { isEqual } from 'lodash';
import { getDeviceConnectionConfig, getDeviceEthernetIcon, getDeviceGsmIcon, getDeviceLegacyWiFiIcon, getDeviceWiFiIcon, } from './connection-config';
import { getDeviceIconState } from 'console/device/icon/device-state';
export function resolveRerender(device) {
    const connection_config = getDeviceConnectionConfig(device);
    const connection_icons = {
        gsm: getDeviceGsmIcon(device),
        wifi: connection_config.has_legacy_wifi
            ? getDeviceLegacyWiFiIcon(device)
            : getDeviceWiFiIcon(device),
        ethernet: getDeviceEthernetIcon(device),
    };
    const setter = {};
    if (!isEqual(device.connection_icons, connection_icons)) {
        setter.connection_icons = connection_icons;
    }
    if (!isEqual(device.connection_config, connection_config)) {
        setter.connection_config = connection_config;
    }
    const iconState = getDeviceIconState(device);
    if (!isEqual(device.iconState, iconState)) {
        setter.iconState = iconState;
    }
    if (Object.keys(setter).length === 0) {
        return device;
    }
    return { ...device, ...setter };
}
export function deviceFromJSON(raw_dev) {
    const device = {
        rf_updating: false,
        rf_updating_successful: false,
        custom_controls_elements__loading: {},
        custom_controls_elements__fail: {},
        service_mode_manual: false,
        filetransfers: [],
    };
    for (const key of Object.keys(raw_dev)) {
        if (key !== 'io') {
            const new_key = key.replace(/-/g, '_');
            device[new_key] = raw_dev[key];
        }
    }
    //@ts-ignore
    for (const key of Object.keys(raw_dev?.io ?? {})) {
        const new_key = key.replace(/-/g, '_');
        //@ts-ignore
        device[new_key] = raw_dev.io[key];
    }
    if (raw_dev.filetransfers != null) {
        device.filetransfers = JSON.parse(JSON.stringify(raw_dev.filetransfers));
    }
    if (device.rf_status != null) {
        const s_rf = device.rf_status;
        const rf = {};
        for (const s_serial of Object.keys(s_rf)) {
            const new_key = s_serial.replace(/^s_/, '');
            rf[new_key] = s_rf[s_serial];
        }
        device.rf_status = rf;
    }
    if (device.last_receive_time != null) {
        device.last_connect_time = device.last_receive_time;
        delete device.last_receive_time;
        delete device.last_receive_time_relative;
    }
    return resolveRerender(device);
}
export function devicesFromJSON(raw_devices) {
    return raw_devices.map(deviceFromJSON);
}
